export default __webpack_public_path__ + "static/media/congrats-img.57548525.png";